import { useEffect, useState } from 'react';

interface ErrorFallbackProps {
  error: Error | null;
}

const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  const [countdown, setCountdown] = useState<number>(5);

  useEffect(() => {
    if (error) {
      try {
        sessionStorage.setItem('__error_boundary_info', JSON.stringify({
          message: error.message,
          stack: error.stack,
          time: Date.now()
        }));
      } catch {
        sessionStorage.removeItem('__error_boundary_info');
      }
    }

    const interval = window.setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.clearInterval(interval);
          window.location.href = '/';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => window.clearInterval(interval);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4">
      <p className="text-center font-sans text-base font-semibold text-foreground">
        Что-то пошло не так
      </p>
      <p className="text-center font-sans text-sm text-muted-foreground">
        Перенаправление на главную через {countdown}...
      </p>
      <div className="flex gap-3">
        <button
          className="rounded-lg bg-primary px-4 py-2 font-sans text-sm font-semibold text-primary-foreground"
          onClick={() => window.location.href = '/'}
          type="button"
        >
          На главную
        </button>
        <button
          className="rounded-lg border border-input bg-background px-4 py-2 font-sans text-sm font-semibold text-foreground"
          onClick={() => window.location.reload()}
          type="button"
        >
          Перезагрузить
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
